<template>
  <div v-if="message.trim()" class="small-margin-bottom-m medium-margin-bottom-z">
    <h2 class="h5 margin-bottom-xs">
      {{ giftMessageText }}
    </h2>
    <p id="gift-message">
      {{ message }}
    </p>
  </div>
</template>

<script setup>
import { ORDER_DETAILS } from 'config';

defineProps({
  message: {
    type: String,
    default: '',
  },
});

const { giftMessageText } = ORDER_DETAILS.giftMessageCard;
</script>
